import React, { useState } from "react";
import PatientInfo1 from "./PatientInfo1";
import Submit from "../pages/submit/Submit";
import MuiStepper from "../components/stepper/MuiSteper";
import TFOneSocketMeasure from "../pages/patientMeasurement/TFOneSocketMeasure";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import OneSocketPatientReview from "./OneSocketPatientReview";

const TFOneSocket = () => {
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);

  const handleNext = () => {
    if (activeOuterStep === formData?.length - 1) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep + 1);
      setActiveInnerStep(0);
    }
  };

  const handleBack = () => {
    if (activeOuterStep === 0) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep - 1);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const formData = [
    {
      id: 1,
      name: "Patient Information",
      innerSteps: [
        { id: 1, name: "Patient Info", isActive: true },
        { id: 2, name: "Amputation Level", isActive: true },
        { id: 3, name: "Amputation Side", isActive: true },
        { id: 4, name: "K Level", isActive: true },
      ],
      formContent: (
        <PatientInfo1
          setActiveInnerStep={setActiveInnerStep}
          handleNext={handleNext}
          handleBack={handleBack}
          formTypeId={8}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 2,
      name: "Product Measurement",
      innerSteps: [
        { id: 1, name: "Measurements", isActive: true },
        { id: 2, name: "One® System", isActive: true },
        { id: 3, name: "Socket Finish", isActive: true },
        { id: 4, name: "Mounting Plate", isActive: true },
        { id: 5, name: "Prosthetic Height", isActive: true },
        { id: 6, name: "Delivery Date", isActive: true },
        { id: 7, name: "Notes", isActive: true },
      ],
      formContent: (
        <TFOneSocketMeasure
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={8}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 4,
      name: "Customer information",
      innerSteps: [],
      formContent: (
        <ClinicInfo
          formTypeId={8}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 5,
      name: "Shipping Information",
      innerSteps: [],
      formContent: (
        <PatientInfo2
          formTypeId={8}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 6,
      name: "Order Review",
      innerSteps: [],
      formContent: (
        <OneSocketPatientReview
          formTypeId={8}
          handleNext={handleNext}
          handleBack={handleBack}
          formName="TT One® Socket"
        />
      ),
    },

    {
      id: 7,
      name: "Submit",
      innerSteps: [],
      formContent: <Submit />,
    },
  ];

  const totalIds = formData.reduce((count) => {
    return count + 1;
  }, 0);

  return (
    <div>
      <MuiStepper
        data={formData}
        innerStep={activeInnerStep}
        setInnerStep={setActiveInnerStep}
        setActiveOuterStep={setActiveOuterStep}
        activeOuterStep={activeOuterStep}
        formName="TF One® Socket"
        totalSteps={totalIds}
      />
    </div>
  );
};

export default TFOneSocket;
